import React, {useState} from "react";
import {Row} from "antd";
import {useTranslation} from "react-i18next";
import {PlusOutlined} from "@ant-design/icons";
import {AssignPermissionPoliciesButton} from "./DisallowedPermissionPoliciesTabStyles";
import DisallowedPermissionPoliciesAssignModal from "./disallowedPermissionPoliciesAssignModal/DisallowedPermissionPoliciesAssignModal";
import {PermissionPolicyList} from "../../permissionPolicyList/PermissionPolicyList";
import {UnassignDisallowedPermissionPolicyButton} from "./unassignDisallowedPermissionPolicyButton/UnassignDisallowedPermissionPolicyButton";
export const DisallowedPermissionPoliciesTab = ({
    userId,
    permissionPolicies = [],
    loading = false,
    csrSearchText = "",
    recall = () => {}
}) => {
    const {t} = useTranslation(["userAuthorization"]);
    const [
        assignPermissionPoliciesModalVisibility,
        setAssignPermissionPoliciesModalVisibility
    ] = useState(false);

    return (
        <div>
            <DisallowedPermissionPoliciesAssignModal
                userId={userId}
                visibility={assignPermissionPoliciesModalVisibility}
                disallowedPermissionPolicies={permissionPolicies}
                onSuccess={() => {
                    setAssignPermissionPoliciesModalVisibility(false);
                    recall();
                }}
                onCancel={() => setAssignPermissionPoliciesModalVisibility(false)}
            />
            <Row type="flex" justify="end">
                <AssignPermissionPoliciesButton
                    size="small"
                    icon={<PlusOutlined />}
                    data-testid="assignPermissionPolicyButton"
                    onClick={() => setAssignPermissionPoliciesModalVisibility(true)}
                >
                    {t("components.assignPermissionPoliciesButton.label", {
                        ns: "userAuthorization"
                    })}
                </AssignPermissionPoliciesButton>
            </Row>
            <PermissionPolicyList
                permissionPolicies={permissionPolicies}
                loading={loading}
                csrSearchText={csrSearchText}
                showActionColumn={true}
                actionButton={(attr, item) => (
                    <span data-testid="unassignDisallowedPermissionPolicy">
                        <UnassignDisallowedPermissionPolicyButton
                            userId={userId}
                            permissionPolicyKey={item?.key}
                            recall={recall}
                        />
                    </span>
                )}
            />
        </div>
    );
};
